import { render } from "./LogoOverlayComponent.vue?vue&type=template&id=5b59a7e0&scoped=true"
import script from "./LogoOverlayComponent.vue?vue&type=script&lang=ts"
export * from "./LogoOverlayComponent.vue?vue&type=script&lang=ts"

import "./LogoOverlayComponent.vue?vue&type=style&index=0&id=5b59a7e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b59a7e0"

export default script